export const onlyEmailRegex = /^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i;
export const usPhoneRegex = /^(\(\s?[0-9]+\s?\)|[0-9]+)\s?[0-9]+\s?-?\s?[0-9]+$/;
export const phoneSpecialCharacters = /[\s\-()]/g;
export const letterMatchingRegex = /[a-zA-Z]+/;
